import { createSelector } from '@reduxjs/toolkit'
import * as selectNodes from './nodes'
import * as selectEdges from './edges'
import type { GraphNode, GraphEdge } from 'types/domain'

interface FocusState {
  id: string
}

interface FocusRootState {
  graph?: {
    focus?: FocusState
  }
}

type EntityMap = Record<string, unknown>

const defaultFocusState: FocusState = {
  id: '',
}


const selectFocus = (state: Record<string, unknown>): FocusState => {
  const graphState = state as FocusRootState
  return graphState.graph?.focus ?? defaultFocusState
}

export default createSelector(selectFocus, selectNodes.all, selectEdges.all, (focus, nodes: EntityMap, edges: EntityMap) => {
  const isNode = nodes[focus?.id] != null
  const isEdge = edges[focus?.id] != null
  return {
    id: focus.id,
    isNode,
    isEdge
  }
})

export const selectFocusedEntity = createSelector(selectFocus, selectNodes.all, selectEdges.all, (focus, nodes, edges): GraphNode | GraphEdge | null => {
  return nodes[focus?.id] ?? edges[focus?.id] ?? null
})
